import { render, staticRenderFns } from "./keyboxs.vue?vue&type=template&id=46803856&scoped=true&"
import script from "./keyboxs.vue?vue&type=script&lang=js&"
export * from "./keyboxs.vue?vue&type=script&lang=js&"
import style0 from "./keyboxs.vue?vue&type=style&index=0&id=46803856&scoped=true&lang=css&"
import style1 from "./keyboxs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46803856",
  null
  
)

export default component.exports